import { render, staticRenderFns } from "./PostProduction.vue?vue&type=template&id=0c39aeca&scoped=true&"
import script from "./PostProduction.vue?vue&type=script&lang=js&"
export * from "./PostProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c39aeca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c39aeca')) {
      api.createRecord('0c39aeca', component.options)
    } else {
      api.reload('0c39aeca', component.options)
    }
    module.hot.accept("./PostProduction.vue?vue&type=template&id=0c39aeca&scoped=true&", function () {
      api.rerender('0c39aeca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/reporting/PostProduction.vue"
export default component.exports